import { createFileRoute } from '@tanstack/react-router'
import { BrandsPage } from '@/features/brands'

// Per-column text filter (example for username)

export const Route = createFileRoute('/_authenticated/brands/')({
  component: BrandsPage,
})
